// ============================================
// CONFIGURACION.JS — Configuración del sistema
// 6 pestañas: Empresa, Servicios, Usuarios, Notificaciones, Integraciones, Seguridad
// ============================================

import React, { useState } from 'react';
import { BarraPestanas } from './utils/filtros';

const PP = "'Poppins', sans-serif";
const colores = { principal: '#5c9adb', oscuro: '#2f5f9e', gris: '#4e5357', grisClaro: '#5e666e', verde: '#5cd4b0', rojo: '#e05c5c', fondo: '#f3f4f4' };
const tarjeta = { background: '#fff', borderRadius: '14px', padding: '20px', marginBottom: '14px' };
const inputStyle = { width: '100%', padding: '10px 12px', border: '1px solid #d0d0d0', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', outline: 'none', color: colores.gris, fontFamily: PP, background: '#fff' };
const labelStyle = { fontSize: '12px', color: colores.grisClaro, display: 'block', marginBottom: '4px', fontFamily: PP };

const serviciosConfig = [
  { id: 1, nombre: 'CCTV / Videovigilancia', icon: '📹', color: '#5c9adb', activo: true },
  { id: 2, nombre: 'Control de acceso', icon: '🔐', color: '#5cd4b0', activo: true },
  { id: 3, nombre: 'Redes e infraestructura', icon: '🌐', color: '#f4a261', activo: true },
  { id: 4, nombre: 'Alarmas y seguridad', icon: '🔔', color: '#e05c5c', activo: true },
  { id: 5, nombre: 'Mantenimiento', icon: '🔧', color: '#a78bfa', activo: true },
  { id: 6, nombre: 'Automatización', icon: '📱', color: '#34d399', activo: false },
];

const integraciones = [
  { nombre: 'Google Maps', icon: '📍', estatus: 'Conectado', desc: 'Navegación y geolocalización' },
  { nombre: 'WhatsApp Business', icon: '💬', estatus: 'No configurado', desc: 'Envío de mensajes a clientes' },
  { nombre: 'Google Drive', icon: '📁', estatus: 'No configurado', desc: 'Almacenamiento de archivos' },
  { nombre: 'Correo SMTP', icon: '✉️', estatus: 'Conectado', desc: 'Envío de correos del sistema' },
  { nombre: 'SAT (facturación)', icon: '🏛️', estatus: 'No configurado', desc: 'Timbrado de facturas CFDI' },
];

const logAccesos = [
  { fecha: '2026-03-30 14:30', usuario: 'Ricardo Vázquez', accion: 'Acceso al sistema', ip: '192.168.1.10' },
  { fecha: '2026-03-30 14:15', usuario: 'Laura Soto', accion: 'Acceso al sistema', ip: '192.168.1.15' },
  { fecha: '2026-03-30 09:00', usuario: 'Carlos Vargas', accion: 'Acceso al sistema', ip: '10.0.0.5' },
  { fecha: '2026-03-29 18:00', usuario: 'Ricardo Vázquez', accion: 'Cambió contraseña de Patricia N.', ip: '192.168.1.10' },
  { fecha: '2026-03-29 08:45', usuario: 'Miguel García', accion: 'Acceso desde celular', ip: '189.203.x.x' },
];

function Configuracion({ pestanaInicial = 'empresa' }) {
  const [tab, setTab] = useState(pestanaInicial);
  const [empresa, setEmpresa] = useState({ nombre: 'Beep México SA de CV', rfc: 'BMX250101XX0', direccion: 'Av. Revolución 1500, Col. Mixcoac, CDMX', telefono: '55 1234 5678', correo: 'contacto@beepmx.com', web: 'www.beepmx.com' });

  const [width] = useState(window.innerWidth);
  const esCelular = width < 768;

  return (
    <div style={{ fontFamily: PP }}>
      <BarraPestanas
        tabs={[
          { key: 'empresa', label: 'Mi empresa' },
          { key: 'servicios', label: 'Servicios' },
          { key: 'notificaciones', label: 'Notificaciones' },
          { key: 'integraciones', label: 'Integraciones' },
          { key: 'seguridad', label: 'Seguridad' },
        ]}
        activo={tab}
        onChange={setTab}
      />

      {tab === 'empresa' && (
        <div style={tarjeta}>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <img src="/Logo Original Cuadrado.png" alt="BeepMX" style={{ width: '80px', height: '80px', borderRadius: '16px', marginBottom: '10px' }} />
            <div style={{ fontSize: '18px', fontWeight: '700', color: colores.gris }}>{empresa.nombre}</div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: esCelular ? '1fr' : '1fr 1fr', gap: '12px' }}>
            {[{ l: 'Razón social', k: 'nombre' }, { l: 'RFC', k: 'rfc' }, { l: 'Dirección fiscal', k: 'direccion' }, { l: 'Teléfono', k: 'telefono' }, { l: 'Correo', k: 'correo' }, { l: 'Sitio web', k: 'web' }].map(f => (
              <div key={f.k}><label style={labelStyle}>{f.l}</label><input value={empresa[f.k]} onChange={e => setEmpresa({ ...empresa, [f.k]: e.target.value })} style={inputStyle} /></div>
            ))}
          </div>
          <button style={{ marginTop: '16px', padding: '10px 20px', background: colores.oscuro, color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', fontFamily: PP }}>Guardar cambios</button>
        </div>
      )}

      {tab === 'servicios' && (
        <div>
          {serviciosConfig.map(s => (
            <div key={s.id} style={{ ...tarjeta, display: 'flex', alignItems: 'center', gap: '12px', opacity: s.activo ? 1 : 0.5 }}>
              <span style={{ fontSize: '28px' }}>{s.icon}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '14px', fontWeight: '600', color: colores.gris }}>{s.nombre}</div>
                <div style={{ fontSize: '11px', color: colores.grisClaro }}>{s.activo ? 'Activo' : 'Inactivo'}</div>
              </div>
              <div style={{ width: '40px', height: '22px', borderRadius: '11px', background: s.activo ? '#1D9E75' : '#d0d0d0', position: 'relative', cursor: 'pointer' }}>
                <div style={{ width: '18px', height: '18px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '2px', left: s.activo ? '20px' : '2px', transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' }} />
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === 'notificaciones' && (
        <div style={tarjeta}>
          <div style={{ fontSize: '14px', fontWeight: '600', color: colores.gris, marginBottom: '14px' }}>Eventos y canales de notificación</div>
          {['Nueva tarea asignada', 'Tarea completada', 'Factura vencida', 'Permiso solicitado', 'Alerta de geofencing', 'Servicio no atendido', 'Documento por vencer'].map((ev, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
              <span style={{ fontSize: '13px', color: colores.gris }}>{ev}</span>
              <div style={{ display: 'flex', gap: '8px' }}>
                {['App', 'Email', 'WhatsApp'].map(ch => (
                  <span key={ch} style={{ padding: '3px 8px', borderRadius: '6px', background: i % 2 === 0 ? '#e8faf5' : '#f3f4f4', color: i % 2 === 0 ? '#1D9E75' : colores.grisClaro, fontSize: '10px', fontWeight: '600' }}>{ch}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {tab === 'integraciones' && (
        <div style={{ display: 'grid', gridTemplateColumns: esCelular ? '1fr' : '1fr 1fr', gap: '12px' }}>
          {integraciones.map((ig, i) => (
            <div key={i} style={{ ...tarjeta, borderLeft: `4px solid ${ig.estatus === 'Conectado' ? '#1D9E75' : '#d0d0d0'}` }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                <span style={{ fontSize: '24px' }}>{ig.icon}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '14px', fontWeight: '600', color: colores.gris }}>{ig.nombre}</div>
                  <div style={{ fontSize: '11px', color: ig.estatus === 'Conectado' ? '#1D9E75' : colores.grisClaro }}>{ig.estatus}</div>
                </div>
              </div>
              <div style={{ fontSize: '12px', color: colores.grisClaro, marginBottom: '10px' }}>{ig.desc}</div>
              <button style={{ padding: '6px 14px', background: colores.fondo, color: colores.grisClaro, border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '11px', fontWeight: '600', cursor: 'pointer', fontFamily: PP }}>Configurar</button>
            </div>
          ))}
        </div>
      )}

      {tab === 'seguridad' && (
        <div>
          <div style={tarjeta}>
            <div style={{ fontSize: '14px', fontWeight: '600', color: colores.gris, marginBottom: '14px' }}>Políticas de seguridad</div>
            {[{ l: 'Contraseña mínima', v: '8 caracteres' }, { l: 'Requiere mayúscula y número', v: 'Sí' }, { l: 'Tiempo de sesión', v: '8 horas' }, { l: 'Intentos antes de bloquear', v: '5' }].map((p, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '9px 0', borderBottom: '1px solid #f0f0f0', fontSize: '13px' }}>
                <span style={{ color: colores.grisClaro }}>{p.l}</span>
                <span style={{ color: colores.gris, fontWeight: '500' }}>{p.v}</span>
              </div>
            ))}
          </div>
          <div style={tarjeta}>
            <div style={{ fontSize: '14px', fontWeight: '600', color: colores.gris, marginBottom: '14px' }}>Últimos accesos</div>
            {logAccesos.map((l, i) => (
              <div key={i} style={{ display: 'flex', gap: '10px', padding: '8px 0', borderBottom: '1px solid #f0f0f0', fontSize: '12px' }}>
                <span style={{ color: colores.grisClaro, minWidth: '120px' }}>{l.fecha}</span>
                <span style={{ color: colores.gris, fontWeight: '500', flex: 1 }}>{l.usuario}</span>
                <span style={{ color: colores.grisClaro }}>{l.accion}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Configuracion;
